
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CategoryContextDirective } from 'ish-core/directives/category-context.directive';

import { CustomCategoryTileComponent } from 'ish-shared/dias/components/category/custom-category-tile/custom-category-tile.component';

@Component({
  selector: 'custom-category-list',
  templateUrl: './custom-category-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CustomCategoryTileComponent,CategoryContextDirective],
})
export class CustomCategoryListComponent {
  readonly categories = input<string[]>(undefined);
}
